import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;
export const fetchConditionList = createAsyncThunk(
    'conditions/fetchCondition',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/condition/v1/list', rejectWithValue)
)
export const fetchPublicConditions = createAsyncThunk(
    'conditions/fetchPublicConditions',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'public/v1/list', rejectWithValue)
)

export const fetchSingleCondition = createAsyncThunk(
    'conditions/fetchSingleCondition',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'public/v1/single', rejectWithValue)
)

export const createUpdateCondition = createAsyncThunk(
    'conditions/createUpdateCondition',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/condition/v1', rejectWithValue)
)


export const addSectionToCondition = createAsyncThunk(
    'conditions/addSectionToCondition',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/condition/v1/add-section', rejectWithValue)
)

export const reorderSections = createAsyncThunk(
    'conditions/reorderSections',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/condition/v1/reorder', rejectWithValue)
)

export const deleteSectionFromCondition = createAsyncThunk(
    'conditions/deleteSectionFromCondition',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/condition/v1/delete-section', rejectWithValue)
)

export const deleteFileFromSection = createAsyncThunk(
    'conditions/deleteFileFromSection',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/condition/v1/delete-file', rejectWithValue)
)


export const deleteCondition = createAsyncThunk(
    'conditions/deleteCondition',
    (arg, { rejectWithValue }) => DataService.delete(arg, path+`client/condition/v1/delete/${arg?.conditionId}`, rejectWithValue)
)

export const toggleStatus= createAsyncThunk(
    'conditions/toggleStatus',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/condition/v1/toggle-status/${arg?.conditionId}`, rejectWithValue)
)

export const publishCondition= createAsyncThunk(
    'conditions/publishCondition',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/condition/v1/publish/${arg?.conditionId}`, rejectWithValue)
)

export const sendActivationLink = createAsyncThunk(
    'conditions/sendActivationLink',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/condition/v1/activation-mail/${arg?.conditionId}`, rejectWithValue)
)

export const sendResetPasswordLink = createAsyncThunk(
    'conditions/sendResetPasswordLink',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/condition/v1/send-reset-password/${arg?.conditionId}`, rejectWithValue)
)

export const getConditionByConditionId = createAsyncThunk(
    'conditions/getConditionByConditionId',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/condition/v1/single/${arg?.conditionId}`, rejectWithValue)
)